export const headers = [
  { header: 'Code', name: 'code' },
  { header: 'Organization Name', name: 'organizationName' },
];
